import React from 'react'
import "./SectionThree.css"
const SectionThree = () => {
  return (
    <div className='section3'>
        <div className='SectionThree'>
        <div className='s3_leftimg'>
            <div className="s3_img1">
        <img src='https://ableton-production.imgix.net/about/photo-3.jpg?dpr=2&fit=crop&h=320&ixjsv=1.1.3&q=50&w=427' alt=''/>
        </div>
        <div className="s3_img2">
        <img src='https://ableton-production.imgix.net/about/photo-4.jpg?dpr=2&fit=crop&h=320&ixjsv=1.1.3&q=50&w=427' alt=''/>
        </div>
        </div>
        <div className='s3_img3'>
            <img src="https://ableton-production.imgix.net/about/photo-5.jpg?dpr=2&fit=crop&h=533&ixjsv=1.1.3&q=50&w=533" alt="" />
        </div>
        <div className='s3-bgc'></div>
    </div>
    </div>
  )
}

export default SectionThree